import {
  Material,
  SupportedMaterial,
} from '@k3/core/src/lib/types/material.interface'
import { loadMaterialWithTextures } from '@k3/core'

export const loadMaterial = (
  material: Material,
  setter: (mat: SupportedMaterial) => void
) => {
  loadMaterialWithTextures(material).then(setter)
}
